module.exports = __webpack_public_path__ + "static/img/preview-04.1fd99b4d.webp";